// For Service UserAssociation
import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import type { IModelResponse } from '../base/dto/base.dto';
import { ModelGETUserAssociationConversation, type IModelGETUserAssociationConversationRequest, type IModelGETUserAssociationConversationResponse } from './dto/user-asso.dto';
import { UserAssociationRepository } from './user-asso.repository';

export class UserAssociationService extends BaseService {
  private userAssociationRepository = new UserAssociationRepository(this.api, this.configService);

  async getUserAssociationConversation(params: IModelGETUserAssociationConversationRequest): Promise<IModelResponse<ModelGETUserAssociationConversation[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETUserAssociationConversation[] = [];
    let resData: IModelResponse<IModelGETUserAssociationConversationResponse[]> = {};
    try {
      const res = await this.userAssociationRepository.getUserAssociationConversation(params);
      resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e: IModelGETUserAssociationConversationResponse) => new ModelGETUserAssociationConversation(e));
        console.log('getUserAssociationConversation', params, resData, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, UserAssociationService.name);
    }
    return {
      data: dataResult,
      totalItems: resData.totalItems || 0,
    }
  }
}